import { Navigate, useParams } from "react-router-dom";

import { useUser } from "components/helper/userContext";
import { useSession } from "components/helper/sessionContext";
import SessionPage from "components/SessionPage";
import Signature from "components/authentificationMode/Signature";
import Photo from "components/authentificationMode/Photo";

const SessionPageGuard = () => {
    const { onlineCode } = useParams();
    const { user } = useUser();
    const { session } = useSession();

    const matchingCodeOnline = onlineCode?.match(/[A-Z]{6}/);
    if (!matchingCodeOnline?.length) {
        return <Navigate replace to={`/`} />;
    }

    if (!user || !session) {
        return <Navigate replace to={`/`} />;
    }

    if (session.isSignatureRequired && user.isSigned === false) {
        return <Signature />;
    }

    const isPhotoEnabled =
        session.scenario.fields.find((f) => f.name === "photo") !== undefined;
    if (isPhotoEnabled && !user.isPhotoReceived) {
        return <Photo />;
    }

    return <SessionPage />;
};
export default SessionPageGuard;
